export default __webpack_public_path__ + "static/media/favicon.c34fcb7f.ico";